import { environment as env } from './environment.base';
export const environment = env;
environment.snfClient = environment.CLIENTS_NAMES.ATLAS;

function init() {
    environment.apiUrl = "https://workflow-server-qa-564877789744.us-central1.run.app"
}

init();
